<template>
  <flat-pickr
    :model-value="modelValue"
    :config="mergedConfig"
    class="form-control"
    :class="inputClass"
    :placeholder="placeholder"
    @on-change="onChange"
  />
</template>

<script>
import FlatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';

export default {
  name: 'AppDatepicker',
  components: { FlatPickr },

  props: {
    modelValue: {
      type: String,
      default: '',
    },
    // 'date' | 'datetime' | 'time'
    mode: {
      type: String,
      default: 'date',
      validator: (v) => ['date', 'datetime', 'time'].includes(v),
    },
    placeholder: {
      type: String,
      default: '',
    },
    inputClass: {
      type: [String, Object, Array],
      default: '',
    },
    // permite sobrescrever/estender qualquer opção flatpickr
    config: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: ['update:modelValue'],

  computed: {
    mergedConfig() {
      // altInput: exibe pt-BR ao usuário, mas o valor do v-model fica em ISO
      const modeConfig =
        this.mode === 'datetime'
          ? {
              enableTime: true,
              time_24hr: true,
              dateFormat: 'Y-m-dTH:i',   // ISO enviado ao backend
              altInput: true,
              altFormat: 'd/m/Y H:i',     // exibição ao usuário
            }
          : this.mode === 'time'
          ? {
              enableTime: true,
              noCalendar: true,
              dateFormat: 'H:i',
              time_24hr: true,
            }
          : {
              dateFormat: 'Y-m-d',        // ISO enviado ao backend
              altInput: true,
              altFormat: 'd/m/Y',         // exibição ao usuário
            };

      return {
        locale: Portuguese,
        allowInput: true,
        disableMobile: true,
        ...modeConfig,
        ...this.config,
      };
    },
  },

  methods: {
    onChange(selectedDates, dateStr) {
      this.$emit('update:modelValue', dateStr);
    },
  },
};
</script>
